











import Vue from 'vue';
import NOC from '@/class/common/const';

export default Vue.extend({
  name: 'Error',
  computed: {
    APP_MODE() { return NOC.APP.MODE; },
  },
});
